/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TextDto } from './TextDto';
import {
    TextDtoFromJSON,
    TextDtoFromJSONTyped,
    TextDtoToJSON,
} from './TextDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfTextDto
 */
export interface ODataPostProcessedResultsOfTextDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfTextDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<TextDto>}
     * @memberof ODataPostProcessedResultsOfTextDto
     */
    value?: Array<TextDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfTextDto
     */
    $type?: ODataPostProcessedResultsOfTextDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfTextDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfTextDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoTextDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.TextDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfTextDtoTypeEnum = typeof ODataPostProcessedResultsOfTextDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfTextDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfTextDto interface.
 */
export function instanceOfODataPostProcessedResultsOfTextDto(value?: unknown): value is ODataPostProcessedResultsOfTextDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfTextDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfTextDtoFromJSON(json: any): ODataPostProcessedResultsOfTextDto {
    return ODataPostProcessedResultsOfTextDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfTextDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfTextDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(TextDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfTextDtoToJSON(value?: ODataPostProcessedResultsOfTextDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(TextDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

